import type { PortfolioMandate } from 'shared';

export const MANDATE_OPTIONS: ReadonlyArray<{
  value: PortfolioMandate;
  label: string;
  description: string;
}> = [
  {
    value: 'SWING_TRADING',
    label: 'Swing Trading',
    description:
      'Short/medium-duration positions managed using entries, stops, R-risk and execution discipline.',
  },
  {
    value: 'LONG_TERM_INVESTING',
    label: 'Long-Term Investing',
    description:
      'Multi-year investments managed using thesis, valuation, allocation and portfolio construction.',
  },
];

export function mandateLabel(mandate: PortfolioMandate): string {
  return MANDATE_OPTIONS.find((option) => option.value === mandate)?.label ?? mandate;
}
